module.exports = __webpack_public_path__ + "assets/images/announcement-1000-desk-occupancy.png";